import FilterConstants from '../../filter-constants';
import * as ToleranceUtils from './tolerance-utils';
import * as CommonUtils from '../../utils/common';

let inductorToleranceIdeal = {
  name: FilterConstants.inductorTolerance.ideal,
  allowedMin: FilterConstants.Limits.LSMALL_COMP_LIMIT,
  allowedMax: FilterConstants.Limits.LBIG_COMP_LIMIT,
  multiplicationFactors: [1],
};

let inductorToleranceFive = {
  name: FilterConstants.inductorTolerance.five,
  allowedMin: FilterConstants.Limits.LSMALL_COMP_LIMIT,
  allowedMax: FilterConstants.Limits.LBIG_COMP_LIMIT,
  nominalFactor: 10000000,
  multiplicationFactors: [0.95, 0.97, 1.0, 1.03, 1.05],
};

let inductorToleranceTen = {
  name: FilterConstants.inductorTolerance.ten,
  allowedMin: FilterConstants.Limits.LSMALL_COMP_LIMIT,
  allowedMax: FilterConstants.Limits.LBIG_COMP_LIMIT,
  nominalFactor: 10000000,
  multiplicationFactors: [0.9, 0.95, 1.0, 1.05, 1.1],
};

let inductorToleranceTwenty = {
  name: FilterConstants.inductorTolerance.twenty,
  allowedMin: FilterConstants.Limits.LSMALL_COMP_LIMIT,
  allowedMax: FilterConstants.Limits.LBIG_COMP_LIMIT,
  nominalFactor: 10000000,
  multiplicationFactors: [0.8, 0.9, 1.0, 1.1, 1.2],
};

let inductorToleranceConfigs = [
  inductorToleranceIdeal,
  inductorToleranceFive,
  inductorToleranceTen,
  inductorToleranceTwenty,
];

// let supportedESeries = [
//   FilterConstants.eSeries.E6,
//   FilterConstants.eSeries.E12,
//   FilterConstants.eSeries.E24,
//   FilterConstants.eSeries.ideal,
// ];

// export function computeNominalValue(idealValue, toleranceInput, forceRoundDirection) {
//   let selectedSeries = toleranceInput.inductorPreferredSeries;
//   let preferredSeries = getSeries(selectedSeries);
//   let nominalValue = ToleranceUtils.computeNominalValue(idealValue, preferredSeries, forceRoundDirection);

//   return nominalValue;
// }

export function getToleranceValues(value, selectedTolerance) {
  if (CommonUtils.isNullOrUndefined(value) || value === 0 || CommonUtils.isNearInfinity(value)) {
    return {
      isToleranceCoerced: false,
      finalTolerance: FilterConstants.inductorTolerance.ideal,
      toleranceArray: [value],
    };
  }

  let toleranceConfig = ToleranceUtils.getToleranceConfig(inductorToleranceConfigs, value, selectedTolerance);
  let isToleranceCoerced = toleranceConfig !== null;
  let finalTolerance = toleranceConfig.name;
  let toleranceArray = ToleranceUtils.getToleranceArray(value, toleranceConfig);
  return {
    isToleranceCoerced: isToleranceCoerced,
    finalTolerance: finalTolerance,
    toleranceArray: toleranceArray,
  };
}

// function getSeries(selectedSeries) {
//   var isSupported = supportedESeries.some((item) => item === selectedSeries);
//   if (!isSupported) throw `Series ${selectedSeries} is not supported. Supported series are ${supportedESeries}`;

//   return ToleranceUtils.getSeries(selectedSeries);
// }
